/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {

};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.AddRespondentAnswerAction.REQUEST_ADDRESPONDENTANSWER:
      return {
        ...state,
    };
    case actions.AddRespondentAnswerAction.ADDRESPONDENTANSWER_RECEIVED:
          return{
      ...state,
    };

    default:
      return state;
  }
};

export default reducer;
